function timeToMinutes(t) {
  const s = String(t || '').trim().slice(0, 5);
  if (!/^\d{2}:\d{2}$/.test(s)) return null;
  const [h, m] = s.split(':').map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
}

function minutesToHHmm(total) {
  const m = Math.max(0, Math.round(Number(total) || 0));
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}

export function windowDurationMinutes(timeFrom, timeTo) {
  const start = timeToMinutes(timeFrom);
  const end = timeToMinutes(timeTo);
  if (start == null || end == null || end <= start) return 0;
  return end - start;
}

export function hasCompleteTimeSearch(filters) {
  const days = Array.isArray(filters?.days) ? filters.days : [];
  const start = timeToMinutes(filters?.time_from);
  const end = timeToMinutes(filters?.time_to);
  return days.length > 0 && start != null && end != null && end > start;
}

export function hasPartialTimeSearch(filters) {
  const days = Array.isArray(filters?.days) ? filters.days : [];
  const hasDays = days.length > 0;
  const hasTime = Boolean(filters?.time_from) || Boolean(filters?.time_to);
  return (hasDays || hasTime) && !hasCompleteTimeSearch(filters);
}

export function buildSchedulesFromTimeFilters(filters) {
  if (!hasCompleteTimeSearch(filters)) return [];
  const start = String(filters.time_from).slice(0, 5);
  const end = String(filters.time_to).slice(0, 5);
  return filters.days.map((d) => ({
    day_of_week: Number(d),
    start_time: `${start}:00`,
    end_time: `${end}:00`,
  }));
}

export function filtersToPrefillSchedules(filters) {
  const schedules = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
  if (!hasCompleteTimeSearch(filters)) return schedules;
  const startMin = timeToMinutes(filters.time_from);
  const endMin = timeToMinutes(filters.time_to);
  if (startMin == null || endMin == null) return schedules;
  const duration = endMin - startMin;
  const slotEnd = duration < 60 ? endMin : startMin + 60;
  filters.days.forEach((d) => {
    const day = Number(d);
    if (day >= 0 && day <= 6) {
      schedules[day].push({
        startTime: minutesToHHmm(startMin),
        endTime: minutesToHHmm(slotEnd),
      });
    }
  });
  return schedules;
}

export function formatTimeSearchLabel(filters, dayOptions = []) {
  const days = (filters?.days || [])
    .map((val) => dayOptions.find((d) => d.value === val)?.label || val)
    .join(', ');
  const start = String(filters?.time_from || '').slice(0, 5);
  const end = String(filters?.time_to || '').slice(0, 5);
  const time = start && end ? `${start}–${end}` : '';
  return [days, time].filter(Boolean).join(' · ');
}
